<ng-container *ngIf="userRoles?.length">

    <mat-card appearance="outlined" class="syn-card" [style.padding]="'1em'">
        <mat-form-field appearance="outline">
            <mat-label>Filtrer</mat-label>
            <input
                #filter
                matInput
                type="text"
                (keyup)="applyFilter(filter.value)"
                placeholder="Filtrer"
            />
            <button
                mat-icon-button
                matSuffix
                (click)="applyFilter('', filter)"
            >
                <mat-icon svgIcon="close"></mat-icon>
            </button>
        </mat-form-field>

        <h2 class="preferences-title">Préférences de communication</h2>

        <mat-table #table [dataSource]="dataSource" matSort matSortActive="$project.name" matSortDirection="asc">

            <!-- name -->
            <ng-container matColumnDef="$project.name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Projet
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <syn-avatar
                        *ngIf="row.projectId === '*'"
                        [matIco]="'star'"
                        [text]="'Tous les projets'"
                        [caption]="'*'"
                        [size]="32"
                    ></syn-avatar>
                    <syn-project-avatar
                        *ngIf="row.projectId !== '*'"
                        [project]="row.$project"
                        [showLegend]="true"
                        [caption]="row.projectId"
                    ></syn-project-avatar>&nbsp;
                    <mat-icon
                        *ngIf="row.$project.status === 'BUILDING'"
                        matTooltip="Ce projet est en Build : l’utilisateur ne pourra pas créer de ticket Run dessus"
                        class="syn-text--warning" svgIcon="alert-outline">
                    </mat-icon>
                    <mat-icon
                        *ngIf="row.$project.status === 'UNPROVISIONED'"
                        matTooltip="Ce projet est en résilié : l’utilisateur ne pourra pas créer de ticket Run dessus"
                        class="syn-text--warning" svgIcon="alert-outline">
                    </mat-icon>
                </mat-cell>
            </ng-container>

            <!-- roles -->
            <ng-container matColumnDef="roles">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Roles
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="syn-flexrow syn-flexrow--fluid">

                        <div>
                            <mat-chip-listbox>
                                <mat-chip disableRipple *ngFor="let chip of row.roles">
                                    {{computeRoleLine(chip)}}
                                </mat-chip>
                            </mat-chip-listbox>
                        </div>

                        <div class="syn-flexrow__cell--minwidth">
                            <button mat-icon-button (click)="displayAclsInformation(row)" color="primary">
                                <mat-icon svgIcon="information-outline"></mat-icon>
                            </button>
                        </div>

                    </div>
                </mat-cell>
            </ng-container>

            <!-- MSO -->
            <ng-container matColumnDef="mso">
                <mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    matTooltip="Envoi d'un email pour information lors d'un Major Service Outage, incident majeur impactant plusieurs clients."
                >
                    MSO
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <syn-in-array [needle]="'MSO'" [stack]="row.communicationTypes"></syn-in-array>
                </mat-cell>
            </ng-container>

            <!-- INCIDENT -->
            <ng-container matColumnDef="incident">
                <mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    matTooltip="Envoi d'un email pour information lors de la déclaration d'un incident sur le projet."
                >
                    INCIDENT
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <syn-in-array [needle]="'INCIDENT'" [stack]="row.communicationTypes"></syn-in-array>
                </mat-cell>
            </ng-container>

            <!-- REQUEST -->
            <ng-container matColumnDef="request">
                <mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    matTooltip="Envoi d'un email pour information lors de la création d'une demande sur le projet."
                >
                    REQUEST
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <syn-in-array [needle]="'REQUEST'" [stack]="row.communicationTypes"></syn-in-array>
                </mat-cell>
            </ng-container>

            <!-- PATCH -->
            <ng-container matColumnDef="patch">
                <mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    matTooltip="Envoi d'un email pour information du patch management."
                >
                    PATCH
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <syn-in-array [needle]="'PATCH'" [stack]="row.communicationTypes"></syn-in-array>
                </mat-cell>
            </ng-container>

            <!-- CHANGE -->
            <ng-container matColumnDef="change">
                <mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    matTooltip="Envoi d'un email pour information lors d'une intervention planifiée."
                >
                    CHANGE
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <syn-in-array [needle]="'CHANGE'" [stack]="row.communicationTypes"></syn-in-array>
                </mat-cell>
            </ng-container>

            <!-- BILLING -->
            <ng-container matColumnDef="billing">
                <mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    matTooltip="Envoi d'un email pour information concernant la partie finance."
                >
                    BILLING
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <syn-in-array [needle]="'BILLING'" [stack]="row.communicationTypes"></syn-in-array>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <mat-paginator
            *ngIf="showPaginator"
            #paginator
            [length]="userRoles?.length"
            [pageSizeOptions]="pageSizeOptions"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
        ></mat-paginator>
    </mat-card>


</ng-container>
